import { render } from "./ShowDivisionalChartImages.vue?vue&type=template&id=d8ec01fe&scoped=true"
import script from "./ShowDivisionalChartImages.vue?vue&type=script&lang=js"
export * from "./ShowDivisionalChartImages.vue?vue&type=script&lang=js"

import "./ShowDivisionalChartImages.vue?vue&type=style&index=0&id=d8ec01fe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ec01fe"]])

export default __exports__